import React, {FunctionComponent} from "react";
import {Link, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

export const SUPPORT_EMAIL = 'office@alpacuna.com';

export const SupportNote: FunctionComponent = () => {
    const {t} = useTranslation();
    return (
        <Typography variant="caption" color="textSecondary" display="block" align="center" sx={{mt: 2}}>
            {t('signupBreeder.support')}{' '}
            <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>
        </Typography>
    );
};
